export const autecProducts = [
  {
    slug: "air-a-serien",
    name: { sv: "AIR A-serien", en: "AIR A Series" },
    category: "Sändarenheter",
    type: "handenhet",
    family: "AIR",
    image: "/images/products/Autec/air_a/1.jpg",
    gallery: [
      "/images/products/Autec/air_a/1.jpg",
      "/images/products/Autec/air_a/2.jpg",
      "/images/products/Autec/air_a/3.jpg",
    ],
    shortDescription: {
      sv: "Kompakt och robust handenhet för säker radiostyrning av industriella maskiner och applikationer. Utrustad med unikt ID-minne och flexibla batterialternativ för hög driftsäkerhet.",
      en: "Compact and robust hand unit for safe radio remote control of industrial machines and applications. Equipped with a unique ID memory and flexible battery options for high operational reliability.",
    },
    features: [
      {
        sv: "Kompakt och robust design för krävande miljöer",
        en: "Compact and robust design for demanding environments",
      },
      {
        sv: "Flexibel konfiguration och enkel installation",
        en: "Flexible configuration and easy installation",
      },
      {
        sv: "Unikt ID-minne för säker kommunikation",
        en: "Unique ID memory for secure communication",
      },
      {
        sv: "Flexibla batterialternativ för lång drifttid",
        en: "Flexible battery options for long operating time",
      },
    ],
    technicalData: [
      {
        label: {
          sv: "Användningstid utan display",
          en: "Operating time without display",
        },
        value: {
          sv: "40 h med internt Li-ion batteri, 16 h med externt Li-ion batteri",
          en: "40 h with internal Li-ion battery, 16 h with external Li-ion battery",
        },
      },
      {
        label: { sv: "Dimensioner", en: "Dimensions" },
        value: "64,5 x 179 x 37,5 mm",
      },
      {
        label: { sv: "Driftstemperatur max", en: "Max operating temperature" },
        value: "55 °C",
      },
      {
        label: { sv: "Driftstemperatur min", en: "Min operating temperature" },
        value: "-20 °C",
      },
      {
        label: {
          sv: "Förvaringstemperatur max",
          en: "Max storage temperature",
        },
        value: "70 °C",
      },
      {
        label: {
          sv: "Förvaringstemperatur min",
          en: "Min storage temperature",
        },
        value: "-40 °C",
      },
      { label: { sv: "Hammingavstånd", en: "Hamming distance" }, value: "≥9" },
      { label: { sv: "IP-klass", en: "IP rating" }, value: "IP65" },
      {
        label: { sv: "Radiofrekvens", en: "Radio frequency" },
        value: "433.05–434.79 MHz, 915–928 MHz",
      },
      { label: { sv: "Vikt", en: "Weight" }, value: "0,25 kg" },
    ],
  },
  {
    slug: "air-lk-neo-serien",
    name: { sv: "AIR LK-NEO-serien", en: "AIR LK-NEO Series" },
    category: "Sändarenheter",
    type: "handenhet",
    family: "AIR",
    image: "/images/products/Autec/air_lk-neo/1.jpg",
    gallery: [
      "/images/products/Autec/air_lk-neo/1.jpg",
      "/images/products/Autec/air_lk-neo/2.jpg",
      "/images/products/Autec/air_lk-neo/3.jpg",
      "/images/products/Autec/air_lk-neo/4.jpg",
      "/images/products/Autec/air_lk-neo/5.jpg",
      "/images/products/Autec/air_lk-neo/6.jpg",
      "/images/products/Autec/air_lk-neo/7.jpg",
      "/images/products/Autec/air_lk-neo/8.jpg",
    ],
    shortDescription: {
      sv: "Flexibel och avancerad handenhet för radiostyrning av kranar, hydrauliska maskiner och mobila applikationer. Erbjuder hög konfigurerbarhet och certifierade säkerhetsfunktioner för krävande installationer.",
      en: "Flexible and advanced hand unit for radio remote control of cranes, hydraulic machines and mobile applications. Offers high configurability and certified safety functions for demanding installations.",
    },
    features: [
      {
        sv: "Hög konfigurerbarhet för olika applikationer",
        en: "High configurability for different applications",
      },
      {
        sv: "Säker radiokommunikation med FHSS-teknik",
        en: "Secure radio communication with FHSS technology",
      },
      {
        sv: "Certifierad säkerhetsfunktion upp till PL e",
        en: "Certified safety function up to PL e",
      },
      {
        sv: "Finns i flera utföranden och konfigurationer",
        en: "Available in multiple variants and configurations",
      },
    ],
    technicalData: [
      {
        label: {
          sv: "Användningstid utan display",
          en: "Operating time without display",
        },
        value: {
          sv: ">16 h med Li-ion batteri, >8 h med NiMH batteri",
          en: ">16 h with Li-ion battery, >8 h with NiMH battery",
        },
      },
      {
        label: { sv: "Dimensioner", en: "Dimensions" },
        value: "207,5 x 85 x 49 mm",
      },
      {
        label: { sv: "Driftstemperatur max", en: "Max operating temperature" },
        value: "55 °C",
      },
      {
        label: { sv: "Driftstemperatur min", en: "Min operating temperature" },
        value: "-20 °C",
      },
      {
        label: {
          sv: "Förvaringstemperatur max",
          en: "Max storage temperature",
        },
        value: "70 °C",
      },
      {
        label: {
          sv: "Förvaringstemperatur min",
          en: "Min storage temperature",
        },
        value: "-40 °C",
      },
      { label: { sv: "IP-klass", en: "IP rating" }, value: "IP65" },
      {
        label: { sv: "Radiofrekvens", en: "Radio frequency" },
        value: "433.05–434.79 MHz, 863–870 MHz, 915–928 MHz",
      },
      { label: { sv: "Räckvidd", en: "Range" }, value: "100 m" },
      {
        label: { sv: "Strömförsörjning", en: "Power supply" },
        value: {
          sv: "3,7 V DC med Li-ion batteri, 3,6 V DC med NiMH batteri",
          en: "3,7 V DC with Li-ion battery, 3,6 V DC with NiMH battery",
        },
      },
      {
        label: { sv: "STOP-funktion", en: "STOP function" },
        value: { sv: "Upp till PL e", en: "Up to PL e" },
      },
      { label: { sv: "Vikt", en: "Weight" }, value: "0,38 kg" },
    ],
  },
  {
    slug: "air-sk-serien",
    name: { sv: "AIR SK-serien", en: "AIR SK Series" },
    category: "Sändarenheter",
    type: "handenhet",
    family: "AIR",
    image: "/images/products/Autec/air_sk/1.jpg",
    gallery: [
      "/images/products/Autec/air_sk/1.jpg",
      "/images/products/Autec/air_sk/2.jpg",
    ],
    shortDescription: {
      sv: "Robust och ergonomisk handenhet för säker radiostyrning av maskiner och industriella applikationer. Stöder säkerhetsnivå upp till PL e med stabil FHSS-kommunikation.",
      en: "Robust and ergonomic hand unit for safe radio remote control of machines and industrial applications. Supports safety level up to PL e with stable FHSS communication.",
    },
    features: [
      {
        sv: "Flexibel radiostyrning för flera maskinfunktioner",
        en: "Flexible radio remote control for multiple machine functions",
      },
      {
        sv: "Stabil radiokommunikation med FHSS-teknik",
        en: "Stable radio communication with FHSS technology",
      },
      {
        sv: "Säkerhetsfunktion certifierad upp till PL e",
        en: "Safety function certified up to PL e",
      },
      {
        sv: "Ergonomisk och portabel design för daglig användning",
        en: "Ergonomic and portable design for daily use",
      },
    ],
    technicalData: [
      {
        label: {
          sv: "Användningstid utan display",
          en: "Operating time without display",
        },
        value: ">16 h",
      },
      {
        label: { sv: "Dimensioner", en: "Dimensions" },
        value: "138 x 60 x 118 mm",
      },
      {
        label: { sv: "Driftstemperatur max", en: "Max operating temperature" },
        value: "55 °C",
      },
      {
        label: { sv: "Driftstemperatur min", en: "Min operating temperature" },
        value: "-20 °C",
      },
      {
        label: {
          sv: "Förvaringstemperatur max",
          en: "Max storage temperature",
        },
        value: "70 °C",
      },
      {
        label: {
          sv: "Förvaringstemperatur min",
          en: "Min storage temperature",
        },
        value: "-40 °C",
      },
      { label: { sv: "IP-klass", en: "IP rating" }, value: "IP65" },
      {
        label: { sv: "Radiofrekvens", en: "Radio frequency" },
        value: "863–870 MHz, 915–928 MHz",
      },
      { label: { sv: "Räckvidd", en: "Range" }, value: "100 m" },
      {
        label: { sv: "Strömförsörjning", en: "Power supply" },
        value: {
          sv: "3,7 V DC med Li-ion batteri",
          en: "3,7 V DC with Li-ion battery",
        },
      },
      {
        label: { sv: "STOP-funktion", en: "STOP function" },
        value: { sv: "Upp till PL e", en: "Up to PL e" },
      },
      { label: { sv: "Vikt", en: "Weight" }, value: "0,45 kg" },
    ],
  },
  {
    slug: "air-aj-serien",
    name: { sv: "AIR AJ-serien", en: "AIR AJ Series" },
    category: "Sändarenheter",
    type: "handenhet",
    family: "AIR",
    image: "/images/products/Autec/air_aj/1.jpeg",
    gallery: [
      "/images/products/Autec/air_aj/1.jpeg",
      "/images/products/Autec/air_aj/2.jpg",
      "/images/products/Autec/air_aj/3.jpg",
      "/images/products/Autec/air_aj/4.jpg",
      "/images/products/Autec/air_aj/5.jpg",
      "/images/products/Autec/air_aj/6.jpg",
    ],
    shortDescription: {
      sv: "Avancerad joystickbaserad handenhet för precis styrning av kranar, mobila maskiner och industriella applikationer. Utrustad med display och realtidsåterkoppling för ökad kontroll.",
      en: "Advanced joystick-based hand unit for precise control of cranes, mobile machines and industrial applications. Equipped with display and real-time feedback for increased control.",
    },
    features: [
      {
        sv: "Flexibel konfiguration med joysticks och reglage",
        en: "Flexible configuration with joysticks and controls",
      },
      {
        sv: "Stabil radiokommunikation med FHSS-teknik",
        en: "Stable radio communication with FHSS technology",
      },
      {
        sv: "Tydlig display med realtidsdata och återkoppling",
        en: "Clear display with real-time data and feedback",
      },
      {
        sv: "Ergonomisk design anpassad för krävande miljöer",
        en: "Ergonomic design adapted for demanding environments",
      },
    ],
    technicalData: [
      {
        label: {
          sv: "Användningstid utan display",
          en: "Operating time without display",
        },
        value: {
          sv: "40 h med Li-ion batteri, 20 h med NiMH batteri",
          en: "40 h with Li-ion battery, 20 h with NiMH battery",
        },
      },
      {
        label: { sv: "Dimensioner", en: "Dimensions" },
        value: "310 x 210 x 190 mm",
      },
      {
        label: { sv: "Driftstemperatur max", en: "Max operating temperature" },
        value: "55 °C",
      },
      {
        label: { sv: "Driftstemperatur min", en: "Min operating temperature" },
        value: "-20 °C",
      },
      {
        label: {
          sv: "Förvaringstemperatur max",
          en: "Max storage temperature",
        },
        value: "70 °C",
      },
      {
        label: {
          sv: "Förvaringstemperatur min",
          en: "Min storage temperature",
        },
        value: "-40 °C",
      },
      { label: { sv: "Hammingavstånd", en: "Hamming distance" }, value: "≥9" },
      { label: { sv: "IP-klass", en: "IP rating" }, value: "IP65" },
      {
        label: { sv: "Radiofrekvens", en: "Radio frequency" },
        value: "433.05–434.79 MHz, 915–928 MHz",
      },
      { label: { sv: "Räckvidd", en: "Range" }, value: "75–100 m" },
      {
        label: { sv: "Strömförsörjning", en: "Power supply" },
        value: {
          sv: "7,2 V DC med NiMH batteri, 7,4 V DC med Li-ion",
          en: "7,2 V DC with NiMH battery, 7,4 V DC with Li-ion",
        },
      },
      {
        label: { sv: "STOP-funktion", en: "STOP function" },
        value: { sv: "Upp till PL d", en: "Up to PL d" },
      },
      { label: { sv: "Vikt", en: "Weight" }, value: "2,5 kg" },
    ],
  },
  {
    slug: "dynamic",
    name: "Dynamic",
    category: "Sändarenheter",
    type: "handenhet",
    family: "Dynamic",
    image: "/images/products/Autec/dynamic/1.jpeg",
    gallery: [
      "/images/products/Autec/dynamic/1.jpeg",
      "/images/products/Autec/dynamic/2.jpeg",
      "/images/products/Autec/dynamic/3.jpg",
      "/images/products/Autec/dynamic/4.jpg",
      "/images/products/Autec/dynamic/5.jpg",
      "/images/products/Autec/dynamic/6.jpg",
      "/images/products/Autec/dynamic/7.jpg",
      "/images/products/Autec/dynamic/8.jpg",
    ],
    shortDescription: {
      sv: "Avancerad handenhet för radiostyrning av hydrauliska maskiner och mobila applikationer. Erbjuder joystickstyrning, realtidsåterkoppling och hög konfigurerbarhet för krävande industriella miljöer.",
      en: "Advanced hand unit for radio remote control of hydraulic machines and mobile applications. Offers joystick control, real-time feedback and high configurability for demanding industrial environments.",
    },
    features: [
      {
        sv: "Avancerad joystickstyrning för hög precision",
        en: "Advanced joystick control for high precision",
      },
      {
        sv: "Stabil radiokommunikation med FHSS-teknik",
        en: "Stable radio communication with FHSS technology",
      },
      {
        sv: "Realtidsåterkoppling och dataöverföring",
        en: "Real-time feedback and data transfer",
      },
      {
        sv: "Hög konfigurerbarhet för anpassade lösningar",
        en: "High configurability for customized solutions",
      },
    ],
    technicalData: [
      {
        label: {
          sv: "Användningstid utan display",
          en: "Operating time without display",
        },
        value: {
          sv: "18,5 h med Li-ion batteri, 11 h med NiMH batteri",
          en: "18,5 h with Li-ion battery, 11 h with NiMH battery",
        },
      },
      {
        label: {
          sv: "Användningstid med display",
          en: "Operating time with display",
        },
        value: {
          sv: "9 h med Li-ion batteri",
          en: "9 h with Li-ion battery",
        },
      },
      {
        label: { sv: "Dimensioner", en: "Dimensions" },
        value: "260 x 177 x 161 mm",
      },
      {
        label: { sv: "Driftstemperatur max", en: "Max operating temperature" },
        value: "55 °C",
      },
      {
        label: { sv: "Driftstemperatur min", en: "Min operating temperature" },
        value: "-25 °C",
      },
      {
        label: {
          sv: "Förvaringstemperatur max",
          en: "Max storage temperature",
        },
        value: "85 °C",
      },
      {
        label: {
          sv: "Förvaringstemperatur min",
          en: "Min storage temperature",
        },
        value: "-40 °C",
      },
      { label: { sv: "Hammingavstånd", en: "Hamming distance" }, value: "≥15" },
      { label: { sv: "IP-klass", en: "IP rating" }, value: "IP65" },
      {
        label: { sv: "Radiofrekvens", en: "Radio frequency" },
        value: "870/915 MHz FHSS, 2,4 GHz",
      },
      { label: { sv: "Räckvidd", en: "Range" }, value: "100 m" },
      {
        label: { sv: "Strömförsörjning", en: "Power supply" },
        value: {
          sv: "7,2 V DC med NiMH batteri, 7,4 V DC med Li-ion",
          en: "7,2 V DC with NiMH battery, 7,4 V DC with Li-ion",
        },
      },
      {
        label: { sv: "STOP-funktion", en: "STOP function" },
        value: { sv: "Upp till PL e, SIL 3", en: "Up to PL e, SIL 3" },
      },
      { label: { sv: "Vikt", en: "Weight" }, value: "1,8 kg" },
    ],
  },
  {
    slug: "dynamic-plus",
    name: "Dynamic+",
    category: "Sändarenheter",
    type: "handenhet",
    family: "Dynamic+",
    image: "/images/products/Autec/dynamic+/1.jpg",
    gallery: [
      "/images/products/Autec/dynamic+/1.jpg",
      "/images/products/Autec/dynamic+/2.jpg",
      "/images/products/Autec/dynamic+/3.jpg",
      "/images/products/Autec/dynamic+/4.jpg",
      "/images/products/Autec/dynamic+/5.jpg",
      "/images/products/Autec/dynamic+/6.jpg",
    ],
    shortDescription: {
      sv: "Avancerad handenhet för hydrauliska maskiner med dynamisk frekvenshantering och realtidsåterkoppling. Optimerad för krävande industriapplikationer med höga krav på säkerhet och precision.",
      en: "Advanced hand unit for hydraulic machines with dynamic frequency management and real-time feedback. Optimized for demanding industrial applications with high requirements for safety and precision.",
    },
    features: [
      {
        sv: "Optimerad för hydrauliska maskiner och applikationer",
        en: "Optimized for hydraulic machines and applications",
      },
      {
        sv: "Stabil radiokommunikation med dynamisk frekvenshantering",
        en: "Stable radio communication with dynamic frequency management",
      },
      {
        sv: "Avancerad realtidsåterkoppling och dataöverföring",
        en: "Advanced real-time feedback and data transfer",
      },
      {
        sv: "Hög konfigurerbarhet för komplexa installationer",
        en: "High configurability for complex installations",
      },
    ],
    technicalData: [
      {
        label: {
          sv: "Användningstid utan display",
          en: "Operating time without display",
        },
        value: {
          sv: "18,5 h med Li-ion-batteri, 11 h med NiMH-batteri",
          en: "18,5 h with Li-ion battery, 11 h with NiMH battery",
        },
      },
      {
        label: {
          sv: "Användningstid med display",
          en: "Operating time with display",
        },
        value: {
          sv: '9 h med 2,8" display Li-ion-batteri',
          en: '9 h with 2,8" display Li-ion battery',
        },
      },
      {
        label: { sv: "Dimensioner", en: "Dimensions" },
        value: "260 x 177 x 161 mm",
      },
      {
        label: { sv: "Driftstemperatur max", en: "Max operating temperature" },
        value: "55 °C",
      },
      {
        label: { sv: "Driftstemperatur min", en: "Min operating temperature" },
        value: "-25 °C",
      },
      {
        label: {
          sv: "Förvaringstemperatur max",
          en: "Max storage temperature",
        },
        value: "85 °C",
      },
      {
        label: {
          sv: "Förvaringstemperatur min",
          en: "Min storage temperature",
        },
        value: "-40 °C",
      },
      { label: { sv: "Hammingavstånd", en: "Hamming distance" }, value: "≥15" },
      { label: { sv: "IP-klass", en: "IP rating" }, value: "IP65" },
      {
        label: { sv: "Radiofrekvens", en: "Radio frequency" },
        value: "870/915 MHz FHSS",
      },
      { label: { sv: "Räckvidd", en: "Range" }, value: "100 m" },
      {
        label: { sv: "Strömförsörjning", en: "Power supply" },
        value: {
          sv: "7,2 V DC med NiMH-batteri, 7,4 V DC med Li-ion",
          en: "7,2 V DC with NiMH battery, 7,4 V DC with Li-ion",
        },
      },
      {
        label: { sv: "UMFS-skydd", en: "UMFS protection" },
        value: {
          sv: "Upp till PL d, cat. 3/SIL 2",
          en: "Up to PL d, cat. 3/SIL 2",
        },
      },
      {
        label: { sv: "STOP-funktion", en: "STOP function" },
        value: { sv: "Upp till PL e, SIL 3", en: "Up to PL e, SIL 3" },
      },
      { label: { sv: "Vikt", en: "Weight" }, value: "1,8 kg" },
    ],
  },
  {
    slug: "dynamic-plus-p",
    name: "Dynamic+P",
    category: "Sändarenheter",
    type: "handenhet",
    family: "Dynamic+P",
    image: "/images/products/Autec/dynamic+p/1.jpeg",
    gallery: [
      "/images/products/Autec/dynamic+p/1.jpeg",
      "/images/products/Autec/dynamic+p/2.jpg",
      "/images/products/Autec/dynamic+p/3.jpg",
      "/images/products/Autec/dynamic+p/4.jpeg",
      "/images/products/Autec/dynamic+p/5.jpg",
      "/images/products/Autec/dynamic+p/6.jpg",
      "/images/products/Autec/dynamic+p/7.jpg",
      "/images/products/Autec/dynamic+p/8.jpg",
    ],
    shortDescription: {
      sv: "Avancerad handenhet för hydrauliska maskiner med snabb kabelbaserad parkoppling och utökad diagnostik via CAN-buss. Anpassad för komplexa system med höga krav på precision och säkerhet.",
      en: "Advanced hand unit for hydraulic machines with fast cable-based pairing and extended diagnostics via CAN bus. Adapted for complex systems with high requirements for precision and safety.",
    },
    features: [
      {
        sv: "Snabb och enkel parkoppling via kabel",
        en: "Fast and easy pairing via cable",
      },
      {
        sv: "Avancerad diagnostik och övervakning via CAN-buss",
        en: "Advanced diagnostics and monitoring via CAN bus",
      },
      {
        sv: "Stabil radiokommunikation med FHSS-teknik",
        en: "Stable radio communication with FHSS technology",
      },
      {
        sv: "Hög konfigurerbarhet för komplexa och krävande system",
        en: "High configurability for complex and demanding systems",
      },
    ],
    technicalData: [
      {
        label: {
          sv: "Användningstid utan display",
          en: "Operating time without display",
        },
        value: {
          sv: "18,5 h med Li-ion-batteri, 11 h med NiMH-batteri",
          en: "18,5 h with Li-ion battery, 11 h with NiMH battery",
        },
      },
      {
        label: {
          sv: "Användningstid med display",
          en: "Operating time with display",
        },
        value: {
          sv: '9 h med 2,8" display Li-ion-batteri',
          en: '9 h with 2,8" display Li-ion battery',
        },
      },
      {
        label: { sv: "Dimensioner", en: "Dimensions" },
        value: "260 x 177 x 161 mm",
      },
      {
        label: { sv: "Driftstemperatur max", en: "Max operating temperature" },
        value: "55 °C",
      },
      {
        label: { sv: "Driftstemperatur min", en: "Min operating temperature" },
        value: "-25 °C",
      },
      {
        label: {
          sv: "Förvaringstemperatur max",
          en: "Max storage temperature",
        },
        value: "85 °C",
      },
      {
        label: {
          sv: "Förvaringstemperatur min",
          en: "Min storage temperature",
        },
        value: "-40 °C",
      },
      { label: { sv: "Hammingavstånd", en: "Hamming distance" }, value: "≥15" },
      { label: { sv: "IP-klass", en: "IP rating" }, value: "IP65" },
      {
        label: { sv: "Radiofrekvens", en: "Radio frequency" },
        value: "870/915 MHz FHSS, 2,4 GHz",
      },
      { label: { sv: "Räckvidd", en: "Range" }, value: "100 m" },
      {
        label: { sv: "Strömförsörjning", en: "Power supply" },
        value: {
          sv: "7,2 V DC med NiMH-batteri, 7,4 V DC med Li-ion",
          en: "7,2 V DC with NiMH battery, 7,4 V DC with Li-ion",
        },
      },
      {
        label: { sv: "UMFS-skydd", en: "UMFS protection" },
        value: {
          sv: "Upp till PL d, cat. 3/SIL 2",
          en: "Up to PL d, cat. 3/SIL 2",
        },
      },
      {
        label: { sv: "STOP-funktion", en: "STOP function" },
        value: { sv: "Upp till PL e, SIL 3", en: "Up to PL e, SIL 3" },
      },
      { label: { sv: "Vikt", en: "Weight" }, value: "1,8 kg" },
    ],
  },
  {
    slug: "lift-t-serien",
    name: { sv: "Lift T-serien", en: "Lift T Series" },
    category: "Sändarenheter",
    type: "handenhet",
    family: "Lift",
    image: "/images/products/Autec/lift-t/1.jpeg",
    gallery: [
      "/images/products/Autec/lift-t/1.jpeg",
      "/images/products/Autec/lift-t/2.jpeg",
      "/images/products/Autec/lift-t/3.jpg",
      "/images/products/Autec/lift-t/4.jpg",
      "/images/products/Autec/lift-t/5.jpg",
    ],
    shortDescription: {
      sv: "Kompakt och robust handenhet för radiostyrning av kranar, telfrar och industriella lyftsystem. Erbjuder lång batteritid och säkerhetsfunktioner certifierade upp till SIL 2 och PL d.",
      en: "Compact and robust hand unit for radio remote control of cranes, hoists and industrial lifting systems. Offers long battery life and safety functions certified up to SIL 2 and PL d.",
    },
    features: [
      {
        sv: "Flexibel radiostyrning för kranar och telfrar",
        en: "Flexible radio remote control for cranes and hoists",
      },
      {
        sv: "Stabil och säker radiokommunikation med lång räckvidd",
        en: "Stable and secure radio communication with long range",
      },
      {
        sv: "Enkel installation, driftsättning och konfiguration",
        en: "Easy installation, commissioning and configuration",
      },
      {
        sv: "Robust och ergonomisk design för daglig användning",
        en: "Robust and ergonomic design for daily use",
      },
    ],
    technicalData: [
      {
        label: {
          sv: "Användningstid utan display",
          en: "Operating time without display",
        },
        value: {
          sv: "45 h (T4B), 90 h med 1,2 Ah batterier (T4C), 110 h med 1,5 Ah batterier (T4C)",
          en: "45 h (T4B), 90 h with 1,2 Ah batteries (T4C), 110 h with 1,5 Ah batteries (T4C)",
        },
      },
      {
        label: { sv: "Dimensioner", en: "Dimensions" },
        value: "64,5 x 179 x 37,5 mm",
      },
      {
        label: { sv: "Driftstemperatur max", en: "Max operating temperature" },
        value: "60 °C",
      },
      {
        label: { sv: "Driftstemperatur min", en: "Min operating temperature" },
        value: "-20 °C",
      },
      {
        label: {
          sv: "Förvaringstemperatur max",
          en: "Max storage temperature",
        },
        value: "70 °C",
      },
      {
        label: {
          sv: "Förvaringstemperatur min",
          en: "Min storage temperature",
        },
        value: "-40 °C",
      },
      { label: { sv: "IP-klass", en: "IP rating" }, value: "IP65" },
      {
        label: { sv: "Radiofrekvens", en: "Radio frequency" },
        value: "2400–2483,5 MHz",
      },
      {
        label: { sv: "Strömförsörjning", en: "Power supply" },
        value: {
          sv: "Li-ion batteri LPM00 eller 3 st AAA 1,5 V",
          en: "Li-ion battery LPM00 or 3 pcs AAA 1,5 V",
        },
      },
      {
        label: { sv: "ATS-funktion", en: "ATS function" },
        value: "SIL 2 / PL d, cat. 3",
      },
      {
        label: { sv: "GSS-funktion", en: "GSS function" },
        value: "SIL 2 / PL d, cat. 3",
      },
      {
        label: { sv: "EMS-funktion", en: "EMS function" },
        value: "SIL 2 / PL d, cat. 3",
      },
      { label: { sv: "Vikt", en: "Weight" }, value: "0,25 kg" },
    ],
  },
  {
    slug: "lift-ht4",
    name: "Lift HT4",
    category: "Sändarenheter",
    type: "handenhet",
    family: "Lift",
    image: "/images/products/Autec/lift-ht4/1.jpg",
    gallery: ["/images/products/Autec/lift-ht4/1.jpg"],
    shortDescription: {
      sv: "Kompakt och ergonomisk enhandshandenhet för lastbilskranar och hydrauliska lyftapplikationer. Erbjuder proportionell styrning med hög precision och anpassningsbar display.",
      en: "Compact and ergonomic one-hand unit for truck cranes and hydraulic lifting applications. Offers proportional control with high precision and customizable display.",
    },
    features: [
      {
        sv: "Optimerad för bekväm enhandsmanövrering",
        en: "Optimized for comfortable one-hand operation",
      },
      {
        sv: "Proportionell styrning för hög precision och kontroll",
        en: "Proportional control for high precision and control",
      },
      {
        sv: "Anpassningsbar display med tydlig avläsning",
        en: "Customizable display with clear readout",
      },
      {
        sv: "Utvecklad och testad för krävande industrimiljöer",
        en: "Developed and tested for demanding industrial environments",
      },
    ],
    technicalData: [
      {
        label: { sv: "Dimensioner", en: "Dimensions" },
        value: "94 x 255 x 123 mm",
      },
      {
        label: { sv: "Driftstemperatur max", en: "Max operating temperature" },
        value: "60 °C",
      },
      {
        label: { sv: "Driftstemperatur min", en: "Min operating temperature" },
        value: "-20 °C",
      },
      {
        label: {
          sv: "Förvaringstemperatur max",
          en: "Max storage temperature",
        },
        value: "70 °C",
      },
      {
        label: {
          sv: "Förvaringstemperatur min",
          en: "Min storage temperature",
        },
        value: "-40 °C",
      },
      {
        label: {
          sv: "Användningstid med display",
          en: "Operating time with display",
        },
        value: "50 h",
      },
      { label: { sv: "IP-klass", en: "IP rating" }, value: "IP65" },
      { label: { sv: "Laddtid", en: "Charging time" }, value: "4 h" },
      {
        label: { sv: "Radiofrekvens", en: "Radio frequency" },
        value: "2,4 GHz FHSS",
      },
      { label: { sv: "Räckvidd", en: "Range" }, value: "75 m" },
      {
        label: { sv: "Strömförsörjning", en: "Power supply" },
        value: "3,6 V DC",
      },
      {
        label: { sv: "ATS-funktion", en: "ATS function" },
        value: { sv: "Upp till PL d", en: "Up to PL d" },
      },
      {
        label: { sv: "Tillbehör", en: "Accessories" },
        value: { sv: "Laddstation ingår", en: "Charging dock included" },
      },
      { label: { sv: "Vikt", en: "Weight" }, value: "0,75 kg" },
    ],
  },
  {
    slug: "mottagarenhet-air-serien",
    name: { sv: "Mottagarenhet AIR-serien", en: "AIR Series Receiver Unit" },
    category: "Mottagarenheter",
    type: "mottagarenhet",
    family: "AIR",
    image: "/images/products/Autec/receiver-air/1.jpeg",
    gallery: [
      "/images/products/Autec/receiver-air/1.jpeg",
      "/images/products/Autec/receiver-air/2.jpeg",
      "/images/products/Autec/receiver-air/3.jpeg",
      "/images/products/Autec/receiver-air/4.jpeg",
      "/images/products/Autec/receiver-air/5.jpg",
      "/images/products/Autec/receiver-air/6.jpeg",
      "/images/products/Autec/receiver-air/7.jpeg",
      "/images/products/Autec/receiver-air/8.jpeg",
      "/images/products/Autec/receiver-air/9.jpg",
      "/images/products/Autec/receiver-air/10.jpeg",
    ],
    shortDescription: {
      sv: "Flexibla och robusta basstationer för radiostyrning av maskiner och industriella applikationer. Stöder dataåterkoppling och är enkla att integrera i befintliga styrsystem.",
      en: "Flexible and robust base stations for radio remote control of machines and industrial applications. Supports data feedback and is easy to integrate into existing control systems.",
    },
    features: [
      {
        sv: "Brett sortiment för olika applikationer och behov",
        en: "Wide range for different applications and needs",
      },
      {
        sv: "Flexibel integration i befintliga styrsystem",
        en: "Flexible integration into existing control systems",
      },
      {
        sv: "Dataåterkoppling för ökad kontroll och övervakning",
        en: "Data feedback for increased control and monitoring",
      },
      {
        sv: "Skalbar och framtidssäker lösning",
        en: "Scalable and future-proof solution",
      },
    ],
    technicalData: [
      {
        label: { sv: "Anslutningsgränssnitt", en: "Connection interface" },
        value: { sv: "Plintar", en: "Terminal blocks" },
      },
      {
        label: { sv: "Antenn", en: "Antenna" },
        value: {
          sv: "Extern med 1, 3 eller 5 m kabel",
          en: "External with 1, 3 or 5 m cable",
        },
      },
      {
        label: { sv: "Dimensioner", en: "Dimensions" },
        value: "53,30 x 127,41 x 96,20 mm",
      },
      { label: { sv: "IP-klass", en: "IP rating" }, value: "IP65" },
      {
        label: { sv: "Max antal utgångar", en: "Max number of outputs" },
        value: { sv: "4 st", en: "4 pcs" },
      },
      {
        label: {
          sv: "Märkström STOP-/säkerhetsutgångar",
          en: "Rated current STOP/safety outputs",
        },
        value: "4 A (250 V AC/30 V DC)",
      },
      {
        label: { sv: "Strömförsörjning", en: "Power supply" },
        value: "ACRDIN: 24–230 V AC, MVRDIN: 12–24 V DC/24 V AC",
      },
      {
        label: { sv: "STOP-funktion", en: "STOP function" },
        value: { sv: "Upp till PL e", en: "Up to PL e" },
      },
      { label: { sv: "Vikt", en: "Weight" }, value: "1,2 kg" },
    ],
  },
  {
    slug: "mottagarenhet-dynamic-serien",
    name: {
      sv: "Mottagarenhet Dynamic-serien",
      en: "Dynamic Series Receiver Unit",
    },
    category: "Mottagarenheter",
    type: "mottagarenhet",
    family: "Dynamic",
    image: "/images/products/Autec/receiver-dynamic/1.jpeg",
    gallery: [
      "/images/products/Autec/receiver-dynamic/1.jpeg",
      "/images/products/Autec/receiver-dynamic/2.jpeg",
      "/images/products/Autec/receiver-dynamic/3.jpg",
      "/images/products/Autec/receiver-dynamic/4.jpeg",
    ],
    shortDescription: {
      sv: "Avancerade basstationer för hydrauliska maskiner med stöd för analoga, PWM- och digitala signaler. Erbjuder CANopen-integration och hög kapacitet för krävande industriella system.",
      en: "Advanced base stations for hydraulic machines with support for analog, PWM and digital signals. Offers CANopen integration and high capacity for demanding industrial systems.",
    },
    features: [
      {
        sv: "Optimerad för hydrauliska system och applikationer",
        en: "Optimized for hydraulic systems and applications",
      },
      {
        sv: "Flexibel integration med CANopen-kommunikation",
        en: "Flexible integration with CANopen communication",
      },
      {
        sv: "Hög kapacitet och skalbarhet för komplexa installationer",
        en: "High capacity and scalability for complex installations",
      },
      {
        sv: "Anpassningsbara anslutningar för olika gränssnitt",
        en: "Adaptable connections for different interfaces",
      },
    ],
    technicalData: [
      {
        label: { sv: "Anslutningsgränssnitt", en: "Connection interface" },
        value: {
          sv: "32-, 50- eller 72-polig kontakt",
          en: "32-, 50- or 72-pin connector",
        },
      },
      {
        label: { sv: "Antenn", en: "Antenna" },
        value: {
          sv: "Extern, förlängningskabel 1 eller 5 m som tillval",
          en: "External, extension cable 1 or 5 m as option",
        },
      },
      {
        label: { sv: "Dimensioner", en: "Dimensions" },
        value: "268 x 343 x 110 mm",
      },
      {
        label: { sv: "Driftstemperatur max", en: "Max operating temperature" },
        value: "70 °C",
      },
      {
        label: { sv: "Driftstemperatur min", en: "Min operating temperature" },
        value: "-25 °C",
      },
      {
        label: {
          sv: "Förvaringstemperatur max",
          en: "Max storage temperature",
        },
        value: "85 °C",
      },
      {
        label: {
          sv: "Förvaringstemperatur min",
          en: "Min storage temperature",
        },
        value: "-40 °C",
      },
      { label: { sv: "IP-klass", en: "IP rating" }, value: "IP65" },
      {
        label: {
          sv: "Märkström STOP-/säkerhetsutgångar",
          en: "Rated current STOP/safety outputs",
        },
        value: {
          sv: "STP_1 = 7,5 A, STP_2 = 7,5 A, SAF_1 = 7,5 A, SAF_2 = 3 A vid 30 V DC",
          en: "STP_1 = 7,5 A, STP_2 = 7,5 A, SAF_1 = 7,5 A, SAF_2 = 3 A at 30 V DC",
        },
      },
      {
        label: { sv: "Strömförsörjning", en: "Power supply" },
        value: "8–30 V DC",
      },
      {
        label: { sv: "UMFS-skydd", en: "UMFS protection" },
        value: { sv: "Upp till PL d", en: "Up to PL d" },
      },
      {
        label: { sv: "STOP-funktion", en: "STOP function" },
        value: { sv: "Upp till PL e", en: "Up to PL e" },
      },
      { label: { sv: "Vikt", en: "Weight" }, value: "3,8 kg" },
    ],
  },
  {
    slug: "mottagarenhet-dynamic-plus-serien",
    name: {
      sv: "Mottagarenhet Dynamic+-serien",
      en: "Dynamic+ Series Receiver Unit",
    },
    category: "Mottagarenheter",
    type: "mottagarenhet",
    family: "Dynamic+",
    image: "/images/products/Autec/receiver-dynamic+/1.jpg",
    gallery: ["/images/products/Autec/receiver-dynamic+/1.jpg"],
    shortDescription: {
      sv: "Kompakt mottagarenhet med stöd för CANopen och J1939 samt inbyggd diagnostik för mobila maskiner. Utrustad med dubbel CAN-kommunikation och säkerhetsfunktioner upp till PL e.",
      en: "Compact receiver unit with support for CANopen and J1939 and built-in diagnostics for mobile machines. Equipped with dual CAN communication and safety functions up to PL e.",
    },
    features: [
      {
        sv: "Kompakt mottagare med hög kapacitet och låg vikt",
        en: "Compact receiver with high capacity and low weight",
      },
      {
        sv: "Dubbel CAN-kommunikation för säker dataöverföring",
        en: "Dual CAN communication for secure data transfer",
      },
      {
        sv: "Inbyggd diagnostik för enkel felsökning och övervakning",
        en: "Built-in diagnostics for easy troubleshooting and monitoring",
      },
      {
        sv: "Säkerhetsfunktioner certifierade för professionell maskindrift",
        en: "Safety functions certified for professional machine operation",
      },
    ],
    technicalData: [
      {
        label: { sv: "Anslutningsgränssnitt", en: "Connection interface" },
        value: {
          sv: "M12 cirkulär kontakt, 10-polig reducerad kontakt eller kabelförskruvning",
          en: "M12 circular connector, 10-pin reduced connector or cable gland",
        },
      },
      {
        label: { sv: "Antenn", en: "Antenna" },
        value: {
          sv: "Intern. Extern finns som tillval med förlängningskabel 1 eller 3 m",
          en: "Internal. External available as option with extension cable 1 or 3 m",
        },
      },
      {
        label: { sv: "Dimensioner", en: "Dimensions" },
        value: "198 x 155 x 71,5 mm",
      },
      {
        label: { sv: "Driftstemperatur max", en: "Max operating temperature" },
        value: "70 °C",
      },
      {
        label: { sv: "Driftstemperatur min", en: "Min operating temperature" },
        value: "-25 °C",
      },
      {
        label: {
          sv: "Förvaringstemperatur max",
          en: "Max storage temperature",
        },
        value: "85 °C",
      },
      {
        label: {
          sv: "Förvaringstemperatur min",
          en: "Min storage temperature",
        },
        value: "-40 °C",
      },
      { label: { sv: "IP-klass", en: "IP rating" }, value: "IP65" },
      {
        label: {
          sv: "Märkström STOP-/säkerhetsutgångar",
          en: "Rated current STOP/safety outputs",
        },
        value: {
          sv: "STP_1 = 3 A, STP_2 = 3 A, SAF_1 = 3 A, SAF_2 = 3 A vid 30 V DC",
          en: "STP_1 = 3 A, STP_2 = 3 A, SAF_1 = 3 A, SAF_2 = 3 A at 30 V DC",
        },
      },
      {
        label: { sv: "Strömförsörjning", en: "Power supply" },
        value: "8–30 V DC",
      },
      {
        label: { sv: "UMFS-skydd", en: "UMFS protection" },
        value: { sv: "Upp till PL d", en: "Up to PL d" },
      },
      {
        label: { sv: "STOP-funktion", en: "STOP function" },
        value: { sv: "Upp till PL e", en: "Up to PL e" },
      },
      { label: { sv: "Vikt", en: "Weight" }, value: "1 kg" },
    ],
  },
  {
    slug: "mottagarenhet-dynamic-plus-p-serien",
    name: {
      sv: "Mottagarenhet Dynamic+P-serien",
      en: "Dynamic+P Series Receiver Unit",
    },
    category: "Mottagarenheter",
    type: "mottagarenhet",
    family: "Dynamic+P",
    image: "/images/products/Autec/receiver-dynamic+p/1.jpeg",
    gallery: [
      "/images/products/Autec/receiver-dynamic+p/1.jpeg",
      "/images/products/Autec/receiver-dynamic+p/2.jpeg",
    ],
    shortDescription: {
      sv: "Avancerade basstationer med stöd för CANopen, J1939 och CODESYS® för maximal flexibilitet. Erbjuder integrerad diagnostik och säkerhetsfunktioner för krävande maskintillämpningar.",
      en: "Advanced base stations with support for CANopen, J1939 and CODESYS® for maximum flexibility. Offers integrated diagnostics and safety functions for demanding machine applications.",
    },
    features: [
      {
        sv: "Avancerad CAN-kommunikation med CANopen och J1939",
        en: "Advanced CAN communication with CANopen and J1939",
      },
      {
        sv: "Hög flexibilitet och anpassningsbarhet med CODESYS®",
        en: "High flexibility and adaptability with CODESYS®",
      },
      {
        sv: "Integrerad diagnostik och realtidsåterkoppling",
        en: "Integrated diagnostics and real-time feedback",
      },
      {
        sv: "Anpassningsbara anslutningar för olika systembehov",
        en: "Adaptable connections for different system needs",
      },
    ],
    technicalData: [
      {
        label: { sv: "Antenn", en: "Antenna" },
        value: {
          sv: "Intern, extern är valbart med 1 eller 3 m förlängningskabel",
          en: "Internal, external available with 1 or 3 m extension cable",
        },
      },
      {
        label: { sv: "Dimensioner", en: "Dimensions" },
        value: "240 x 186 x 83 mm",
      },
      {
        label: { sv: "Driftstemperatur max", en: "Max operating temperature" },
        value: "70 °C",
      },
      {
        label: { sv: "Driftstemperatur min", en: "Min operating temperature" },
        value: "-25 °C",
      },
      {
        label: {
          sv: "Förvaringstemperatur max",
          en: "Max storage temperature",
        },
        value: "85 °C",
      },
      {
        label: {
          sv: "Förvaringstemperatur min",
          en: "Min storage temperature",
        },
        value: "-40 °C",
      },
      { label: { sv: "IP-klass", en: "IP rating" }, value: "IP65" },
      {
        label: { sv: "Strömförsörjning", en: "Power supply" },
        value: "8–30 V DC",
      },
      {
        label: { sv: "UMFS-skydd", en: "UMFS protection" },
        value: { sv: "Upp till PL d", en: "Up to PL d" },
      },
      {
        label: { sv: "STOP-funktion", en: "STOP function" },
        value: { sv: "Upp till PL e", en: "Up to PL e" },
      },
      { label: { sv: "Vikt", en: "Weight" }, value: "1,2 kg" },
    ],
  },
  {
    slug: "mottagarenhet-lift-serien",
    name: { sv: "Mottagarenhet Lift-serien", en: "Lift Series Receiver Unit" },
    category: "Mottagarenheter",
    type: "mottagarenhet",
    family: "Lift",
    image: "/images/products/Autec/receiver-lift/1.jpg",
    gallery: [
      "/images/products/Autec/receiver-lift/1.jpg",
      "/images/products/Autec/receiver-lift/2.jpeg",
      "/images/products/Autec/receiver-lift/3.jpg",
    ],
    shortDescription: {
      sv: "Kompakta och robusta basstationer för radiostyrning av kranar och lyftapplikationer. Stöder flexibla utgångar, utbyggnadsmöjligheter och säkerhetsfunktioner upp till SIL 2 och PL d.",
      en: "Compact and robust base stations for radio remote control of cranes and lifting applications. Supports flexible outputs, expansion options and safety functions up to SIL 2 and PL d.",
    },
    features: [
      {
        sv: "Kompakt och robust design för enkel installation",
        en: "Compact and robust design for easy installation",
      },
      {
        sv: "Flexibla utgångar och kommunikationsgränssnitt",
        en: "Flexible outputs and communication interfaces",
      },
      {
        sv: "Stabil radiokommunikation med hög driftsäkerhet",
        en: "Stable radio communication with high operational reliability",
      },
      {
        sv: "Utbyggnadsmöjligheter med expansionskort",
        en: "Expansion options with expansion cards",
      },
    ],
    technicalData: [
      {
        label: { sv: "Anslutningsgränssnitt", en: "Connection interface" },
        value: {
          sv: "Kabelförskruvning M20 och M25, kontakt 16- och 24-polig",
          en: "Cable gland M20 and M25, connector 16- and 24-pin",
        },
      },
      {
        label: { sv: "Antenn", en: "Antenna" },
        value: { sv: "Intern", en: "Internal" },
      },
      {
        label: { sv: "Dimensioner", en: "Dimensions" },
        value: "150 x 134,5 x 60 mm",
      },
      {
        label: { sv: "Driftstemperatur max", en: "Max operating temperature" },
        value: "70 °C",
      },
      {
        label: { sv: "Driftstemperatur min", en: "Min operating temperature" },
        value: "-20 °C",
      },
      {
        label: {
          sv: "Förvaringstemperatur max",
          en: "Max storage temperature",
        },
        value: "70 °C",
      },
      {
        label: {
          sv: "Förvaringstemperatur min",
          en: "Min storage temperature",
        },
        value: "-40 °C",
      },
      { label: { sv: "IP-klass", en: "IP rating" }, value: "IP65" },
      {
        label: {
          sv: "Max antal expansionskort",
          en: "Max number of expansion cards",
        },
        value: { sv: "1 st", en: "1 pcs" },
      },
      {
        label: { sv: "Max antal utgångar", en: "Max number of outputs" },
        value: { sv: "11 st", en: "11 pcs" },
      },
      {
        label: {
          sv: "Märkström STOP-/säkerhetsutgångar",
          en: "Rated current STOP/safety outputs",
        },
        value: "5 A – 250 V AC",
      },
      {
        label: {
          sv: "Märkström styrutgångar",
          en: "Rated current control outputs",
        },
        value: "5 A – 250 V AC",
      },
      {
        label: { sv: "Strömförsörjning", en: "Power supply" },
        value: "24–240 V AC",
      },
      {
        label: { sv: "GSS-funktion", en: "GSS function" },
        value: "SIL 2 / PL d, cat. 3",
      },
      { label: { sv: "Vikt", en: "Weight" }, value: "1 kg" },
    ],
  },
];

export const autecTransmitterProducts = autecProducts.filter(
  (product) => product.category === "Sändarenheter",
);

export const autecReceiverProducts = autecProducts.filter(
  (product) => product.category === "Mottagarenheter",
);

export const autecProductGroups = [
  {
    id: "transmitters",
    title: { sv: "Sändarenheter", en: "Transmitter units" },
    description: {
      sv: "Ergonomiska och konfigurerbara sändare för säker och precis radiostyrning.",
      en: "Ergonomic and configurable transmitters for safe and precise radio remote control.",
    },
    cta: { sv: "Visa fler sändarenheter", en: "Show more transmitter units" },
    items: autecTransmitterProducts,
  },
  {
    id: "receivers",
    title: { sv: "Mottagarenheter", en: "Receiver units" },
    description: {
      sv: "Robusta och flexibla mottagare med hög driftsäkerhet och enkel integration.",
      en: "Robust and flexible receivers with high operational reliability and easy integration.",
    },
    cta: { sv: "Visa fler mottagarenheter", en: "Show more receiver units" },
    items: autecReceiverProducts,
  },
];
